// extracted by mini-css-extract-plugin
export var card = "_nb-1";
export var summary = "_nb-0";
export var unreadDot = "_nb-2";